import i18next, { type LoggerModule } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./i18n/en.json";
import es from "./i18n/es.json";
import ptBR from "./i18n/pt-BR.json";

const noopLogger: LoggerModule = {
  type: "logger",
  log: () => {},
  warn: () => {},
  error: () => {}
};

const i18n = i18next.createInstance();

if (!i18n.isInitialized) {
  i18n
    .use(noopLogger)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "pt-BR",

      supportedLngs: ["en", "es", "pt-BR"],
      resources: {
        en: { translation: en },
        es: { translation: es },
        "pt-BR": { translation: ptBR }
      },

      interpolation: { escapeValue: false },

      detection: {
        order: ["querystring", "localStorage", "htmlTag", "navigator"],
        lookupQuerystring: "lang",
        caches: ["localStorage"],
        convertDetectedLanguage: (lng: string) =>
          lng?.toLowerCase().startsWith("pt") ? "pt-BR" : lng
      },

      debug: false,
      saveMissing: false,
      returnNull: false,
      returnEmptyString: false,
      parseMissingKeyHandler: () => "",
      react: { useSuspense: false }
    });
}

export default i18n;
